<template>
  <v-container fluid class="py-0">
    <v-checkbox class="mt-0" @change="onChange" :label="label" :input-value="value" hide-details></v-checkbox>
    <div v-if="error" class="error--text">
      <small>{{ errorMessages }}</small>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  props: ["label", "items", "value", "error", "error-messages", "id"],
  name: "checkbox-single",
  methods: {
    onChange: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>